"use strict";

var $ = require("jquery");

$(document).ready(function () {

    if ($('.wp-block-product-advice-tool').length > 0) {

        const advice = $('.wp-block-product-advice-tool .advice');
        advice.hide();

        function checkSelectedElements() {
            let isFiltered = false;
            $('.wp-block-product-advice-tool .filters .facetwp-facet select').each(function () {
                if ($(this).val().length > 0) {
                    isFiltered = true;
                }
            })
            if (isFiltered) {
                advice.show();
            } else {
                advice.hide();
            }
        }

        checkSelectedElements();

        $('.wp-block-product-advice-tool .filters .facetwp-facet').each(function () {
            $(this).on('change', function () {
                document.addEventListener('facetwp-loaded', function () {
                    checkSelectedElements();
                });
            });
        })

        $('.wp-block-product-advice-tool .facetwp-reset').on('click', function () {
            checkSelectedElements();

            document.addEventListener('facetwp-loaded', function () {
                advice.hide();
            });
        })

        $(".btn-scroll").on('click', function () {
            $('html, body').animate({
                scrollTop: $(".facetwp-buttons").offset().top
            });
        });
    }
});